exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hotel-approve[data-v-2450e98c]{background-color:#f0f0f0;height:100%}.hotel-approve-container[data-v-2450e98c]{padding:20px;width:100%}", ""]);

// exports
